module.exports = __webpack_public_path__ + "img/show_cn_text_13.69475db2.png";